module.exports = __webpack_public_path__ + "static/img/87008A_2_3_R_20190715_LC.17803a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87008A_2_3_R_20190715_LC.png
// module id = 5eS+
// module chunks = 0